module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [(!_vm.isAnonymous) ? [_c('div', {
    staticClass: "asterisk-container"
  }, [_vm._v("\n\t\t\tSi vous êtes assujetti à l’IFI (Impôt sur la Fortune Immobilière) et pour gagner du temps, vous pouvez télécharger directement votre dernière déclaration d’IFI\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "row start"
  }, [_c('div', {
    staticClass: "btn btn-red ctn-icon light",
    on: {
      "click": _vm.fileInput
    }
  }, [_c('span', {
    staticClass: "icon-button-add"
  }), _vm._v("\n\t\t\t\tTélécharger\n\t\t\t\t"), _c('input', {
    attrs: {
      "id": "input-file",
      "type": "file"
    },
    on: {
      "change": _vm.setFile
    }
  })]), _vm._v(" "), (_vm.file) ? _c('div', {
    staticClass: "filename"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.file.name) + "\n\t\t\t")]) : _vm._e()])] : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label three"
  }, [_c('label', {
    attrs: {
      "for": "montant"
    }
  }, [_vm._v("Montant")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    attrs: {
      "type": "text",
      "name": "montant"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.currencies,
      "selected": _vm.currency
    },
    on: {
      "change": function($event) {
        _vm.currency = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49c37038"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/MyPatrimonialLandscape/ISF.vue
// module id = 1121
// module chunks = 0